module.exports = __webpack_public_path__ + "img/pethouse15.e44df25b.jpg";